module.exports = __webpack_public_path__ + "static/media/humza icons-06.1f0696c7.svg";